module.exports = __webpack_public_path__ + "static/media/nn-Hurtigbenevning-instruction-n.1f9bc4e0.mp3";